<script setup>
import Breadcrumbs from '@/components/blog/Breadcrumbs.vue'
import CategoryNav from '@/components/blog/CategoryNav.vue'
import PostCard from '@/components/blog/PostCard.vue'
import PostPagination from '@/components/blog/PostPagination.vue'
import SectionHeading from '@/components/ui/SectionHeading.vue'

defineProps({
    category: { type: Object, required: true },
    posts: { type: Object, required: true },
    categories: { type: Array, default: () => [] },
    breadcrumbs: { type: Array, default: () => [] },
})
</script>

<template>
    <Head>
        <title>{{ category.meta_title }}</title>
        <meta
            head-key="description"
            name="description"
            :content="category.meta_description || ''"
        />
    </Head>

    <section class="bg-white pt-32 pb-20 md:pt-40 md:pb-28">
        <div class="mx-auto max-w-7xl px-6 lg:px-10">
            <Breadcrumbs :items="breadcrumbs" />

            <div class="mt-8 max-w-2xl">
                <SectionHeading
                    eyebrow="Rubrika"
                    :title="category.name"
                    :lede="category.description || ''"
                />
            </div>

            <div class="mt-10">
                <CategoryNav
                    :categories="categories"
                    :active-slug="category.slug"
                />
            </div>

            <div
                class="mt-12 grid gap-6 md:grid-cols-2 md:gap-8 lg:grid-cols-3"
                v-if="posts.data.length"
            >
                <PostCard
                    v-for="post in posts.data"
                    :key="post.slug"
                    :post="post"
                />
            </div>

            <p
                class="mt-16 text-lg text-zinc-600"
                v-else
            >
                V této rubrice zatím nemáme žádný článek.
            </p>

            <PostPagination
                :links="posts.links"
                :last-page="posts.last_page"
            />
        </div>
    </section>
</template>
